import { getDefaultTransition, zIndex } from '@billy/design-system'
import { css } from '@emotion/core'

import { COLOR as SCROLLBAR_COLOR, COLOR_HOVER as SCROLLBAR_COLOR_HOVER, SIZE as SCROLLBAR_SIZE } from './scrollbars'

export const librariesOverrides = css`
  /*
    Lumen floating surfaces (Menu, Select, Search) render through a portal on
    <body> and default to z-index 50, which is below Billy's own scale — they
    would be painted behind a Drawer or Modal. The variable has to be set here
    rather than on a wrapper: the portal is not a DOM descendant of the
    component that opens it.
  */
  body {
    --lumen-menu-z-index: ${zIndex.Dropdown};
  }

  /*
    Same problem for the DatePicker/PeriodPicker popovers, which portal on
    <body> too but hardcode z-index 10 with no variable to override. They are
    the direct child of the portal wrapper, unlike Lumen's own Dialog whose
    panel sits inside an overlay that must keep its own stacking order.
  */
  div[data-floating-ui-portal] > [role='dialog'] {
    z-index: ${zIndex.Dropdown};
  }

  .simplebar-scroll-content {
    box-sizing: content-box;
  }

  .simplebar-track {
    &.simplebar-vertical {
      &,
      .simplebar-scrollbar:before {
        width: ${SCROLLBAR_SIZE};
      }
    }
    &.simplebar-horizontal {
      &,
      .simplebar-scrollbar:before {
        height: ${SCROLLBAR_SIZE};
      }
    }

    .simplebar-scrollbar {
      &:before {
        left: 0;
        right: 0;
        border-radius: ${SCROLLBAR_SIZE};
        background: transparent;
        ${getDefaultTransition('background', 'opacity')};
      }

      &.simplebar-visible {
        &:before {
          opacity: 1;
          background: ${SCROLLBAR_COLOR};
        }

        &.simplebar-hover {
          &:before {
            opacity: 1;
            background: ${SCROLLBAR_COLOR_HOVER};
          }
        }
      }
    }
  }
`
